/* eslint-disable react/prop-types */
import React from 'react';
import PageWrapper from '../PageWrapper/PageWrapper';
import NavBar from '../NavBar/NavBar';

interface Props {
  children: React.ReactNode;
}

const RouteContainer: React.FC<Props> = (props) => {
  return (
    <div>
      <PageWrapper>
        <NavBar />
        {props.children}
      </PageWrapper>
    </div>
  );
};

export default RouteContainer;
